import React from "react";
import { Button, Menu, MenuItem } from "@material-ui/core";
import { Menu as MenuIcon } from "@material-ui/icons";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Area } from "types";
import { Logo } from "assets";
import { Icon, Text } from "shared";
import { SPACING } from "theme";
import { isUsMarket } from "utils/market";
import { isContentOnly } from "utils/appMode";
import { navVisible } from "routes/content/contentFeatures";
import { css } from "@emotion/css";

const CollapsedMenu: React.VFC = () => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const closeMenu = () => setAnchorEl(null);

  return (
    <header className={styles.header}>
      <Icon of={Logo} size={2} />
      <Button aria-controls="menu" aria-haspopup="true" onClick={handleClick} aria-label="Expand navigation">
        <MenuIcon fontSize="large" />
      </Button>
      <Menu disableScrollLock anchorEl={anchorEl} open={!!anchorEl} onClose={closeMenu} style={{ marginLeft: "auto" }}>
        {navVisible(Area.Users) && (
          <MenuItem component={Link} to={Area.Users} onClick={closeMenu}>
            {t("views.users")}
          </MenuItem>
        )}
        {navVisible(Area.Patients) && (
          <MenuItem component={Link} to={Area.Patients} onClick={closeMenu}>
            {t("views.patient")}
          </MenuItem>
        )}
        {navVisible(Area.Therapists) && (
          <MenuItem component={Link} to={Area.Therapists} onClick={closeMenu}>
            {t("views.therapist")}
          </MenuItem>
        )}
        {navVisible(Area.Hcps) && (
          <MenuItem component={Link} to={Area.Hcps} onClick={closeMenu}>
            {t("views.hcps")}
          </MenuItem>
        )}
        {navVisible(Area.HealthCareOrganizations) && (
          <MenuItem component={Link} to={Area.HealthCareOrganizations} onClick={closeMenu}>
            {t("views.health_care_organizations")}
          </MenuItem>
        )}
        {navVisible(Area.Reports) && (
          <MenuItem component={Link} to={Area.Reports} onClick={closeMenu}>
            {t("views.reports")}
          </MenuItem>
        )}
        {navVisible(Area.RCM) && isUsMarket && (
          <MenuItem component={Link} to={Area.RCM} onClick={closeMenu}>
            {t("views.rcm")}
          </MenuItem>
        )}
        {(navVisible(Area.Other) || isContentOnly) && (
          <MenuItem component={Link} to={Area.Other} onClick={closeMenu}>
            {t("views.other")}
          </MenuItem>
        )}
        <MenuItem component={Link} to={Area.Logout} onClick={closeMenu} style={{ marginTop: SPACING * 3 }}>
          <Text secondary>{t("dropdown.logout")}</Text>
        </MenuItem>
      </Menu>
    </header>
  );
};

export default CollapsedMenu;

const styles = {
  header: css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1100;
    background-color: #fff;
    box-shadow: 0px 2px 10px rgba(42, 63, 88, 0.0680452);
    padding: 0 ${3 * SPACING}px;
  `,
};
